import AppDataService from "./AppDataService";

const COMMON_BASE = 'General'

export default class GeneralDataService {

    static async getCountries() {
        return await AppDataService.get(`${COMMON_BASE}/GetCountries`);
    }

    static async getStates() {
        return await AppDataService.get(`${COMMON_BASE}/GetStates`);
    }

    static async getTaxYears() {
        return await AppDataService.get(`${COMMON_BASE}/GetTaxYears`);
    }

    static async validateZipCode(data) {
        return await AppDataService.post(`${COMMON_BASE}/ValidateZipcode`, data);
    }

    static async get94xTaxYears(params) {
        return await AppDataService.get(`${COMMON_BASE}/Get94xTaxYears`, { params });
    }

    static async getGeneralSetting() {
        return await AppDataService.get(`${COMMON_BASE}/GetGeneralSetting`);
    }

    static async saveMaskAndUnMask(params) {
        return await AppDataService.put(`${COMMON_BASE}/SaveW9MaskAndUnMask`, {}, { params: params } );
    }

    static async saveGeneralInfo(params) {
        return await AppDataService.put(`${COMMON_BASE}/SaveW9FormFields`, {}, { params: params } );
    }

    static async saveScheduleDate(params) {
        return await AppDataService.put(`${COMMON_BASE}/SaveScheduleDate`, {}, { params: params } );
    }
    
    static async saveSupportMail(params) {
        return await AppDataService.put(`${COMMON_BASE}/SaveSupportMail`, {}, {params: params} );
    }
    
    static async saveIsEmailOptOut(params) {
        return await AppDataService.put(`${COMMON_BASE}/SaveIsEmailOptOut`, {}, {params: params} );
    }
    
    static async saveIsRecipientTinUnMask(params) {
        return await AppDataService.put(`${COMMON_BASE}/SaveIsRecipientTinUnMask`, {}, {params: params} );
    }

    static async saveIsFormsRoutingToUSPSMail(params) {
        return await AppDataService.put(`${COMMON_BASE}/SaveIsFormsRoutingToUSPSMail`, {}, {params: params} );
    }

    static async getSalesTaxAdminStatus() {
        return await AppDataService.get(`${COMMON_BASE}/GetSalesTaxAdminStatusAsyn`);
    }
}